<script lang="ts">
	import FireplaceSVG from "./FireplaceSVG.svelte";
	import FacebookLogo from "./Facebook_Logo_Secondary.svg";
	import { page } from "$app/stores";
	import { getClassicWebUrl } from "./currentUser";

	const CLASSIC_WEB_URL = getClassicWebUrl();

	const showFooter = !$page.data.isInsideConnect;
</script>

{#if showFooter}
	<div class="mt-20 min-h-64 w-full bg-nxgray-600 py-12">
		<div class="flex w-full justify-center bg-nxgray-600">
			<div class="container-1200 flex flex-wrap items-start justify-between">
				<div class="flex w-full flex-col lg:flex-row">
					<div class="[&>svg]:mb-6 [&>svg]:mr-16"><FireplaceSVG /></div>
					<div class="flex w-full flex-wrap justify-between">
						<div class="flex flex-wrap justify-start">
							<div class="mb-6 inline-block align-top md:mb-0">
								<h3 class="mb-6 block text-sm text-gray-500">Company</h3>
								<div class="flex min-w-56 flex-col flex-wrap text-white">
									<a class="mb-2 cursor-pointer hover:text-gray-200" href="https://www.smore.com/about/" target="_blank">About</a>
									<a class="mb-2 cursor-pointer hover:text-gray-200" href="https://www.smore.com/privacy-policy/" target="_blank"
										>Privacy</a>
									<a class="mb-2 cursor-pointer hover:text-gray-200 md:mb-0" href="https://www.smore.com/terms/" target="_blank">Terms</a>
								</div>
							</div>
							<div class="mb-6 inline-block align-top md:mb-0">
								<h3 class="mb-6 block text-sm text-gray-500">Resources</h3>
								<div class="mr-12 flex flex-col flex-wrap text-white lg:min-w-56">
									<a class="mb-2 cursor-pointer hover:text-gray-200" href="https://help.smore.com/" target="_blank">Help Center</a>
									<a class="mb-2 cursor-pointer hover:text-gray-200" href="/templates" target="_blank">Educator Hive</a>
									<a class="mb-2 cursor-pointer hover:text-gray-200" href="https://www.smore.com/blog/" target="_blank">Blog</a>
								</div>
							</div>
						</div>
						<div class="flex flex-wrap items-baseline justify-start">
							<div class="">
								<h3 class="mb-6 block text-sm text-gray-500">Smore Pro</h3>
								<div class="min-w-56 text-white">
									<a class="mb-2 block cursor-pointer hover:text-gray-200" href="{CLASSIC_WEB_URL}/educators">Educator Pricing</a>
									<a class="mb-2 block cursor-pointer hover:text-gray-200" href="https://www.smore.com/demo/?utm_source=app_footer">
										Smore for Teams Pricing
									</a>
									<a class="mb-2 block cursor-pointer hover:text-gray-200" href="{CLASSIC_WEB_URL}/business"> Business Pricing </a>
								</div>
							</div>
							<div class="mt-6 md:mt-0">
								<h3 class="mb-6 block text-sm text-gray-500">Social Media</h3>
								<div class="flex flex-wrap items-center justify-start gap-4">
									<a class="flex items-center justify-center" href="https://www.facebook.com/smorepages" rel="noopener" target="_blank">
										<img src={FacebookLogo} alt="Facebook logo" />
									</a>
									<a
										class="flex items-center justify-center"
										href="https://www.youtube.com/channel/UCt4lNwu5qhlnQqLgnkpuNgA"
										rel="noopener"
										target="_blank">
										<svg width="29.6" height="21" viewBox="0 0 12 8.5" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M10.6752 0.254172C11.1913 0.392811 11.5995 0.801027 11.7381 1.31707C11.9923 2.25674 12 4.20539 12 4.20539C12 4.20539 12
                        6.16175 11.7458 7.09371C11.6072 7.60976 11.199 8.01797 10.6829 8.15661C9.75096 8.41078 6 8.41078 6 8.41078C6 8.41078
                        2.24904 8.41078 1.31707 8.15661C0.801027 8.01797 0.392811 7.60976 0.254172 7.09371C0 6.15404 0 4.20539 0 4.20539C0 4.20539
                        0 2.25674 0.24647 1.32478C0.385109 0.808729 0.793325 0.400513 1.30937 0.261874C2.24133 0.00770217 5.9923 0 5.9923 0C5.9923
                        0 9.74326 0 10.6752 0.254172ZM7.91017 4.20539L4.79849 6.0077V2.40308L7.91017 4.20539Z"
												fill="white" />
										</svg>
									</a>
									<a class="flex items-center justify-center" href="https://www.pinterest.com/smoreflyers/" rel="noopener" target="_blank">
										<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"
											><path
												d="M10 0C4.477 0 0 4.477 0 10c0 4.236 2.636 7.858 6.356 9.315-.088-.791-.167-2.008.034-2.872.182-.78 1.173-4.97 1.173-4.97s-.3-.6-.3-1.485c0-1.39.807-2.429 1.81-2.429.853 0 1.265.64 1.265 1.409 0 .858-.546 2.14-.828 3.33-.235.995.5 1.806 1.481 1.806 1.777 0 3.144-1.873 3.144-4.579 0-2.394-1.72-4.068-4.177-4.068-2.846 0-4.516 2.134-4.516 4.34 0 .86.331 1.78.744 2.282a.299.299 0 0 1 .07.287c-.076.315-.245.995-.278 1.134-.043.183-.145.222-.334.133-1.25-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.051 6.607-6.051 3.47 0 6.165 2.472 6.165 5.775 0 3.447-2.173 6.22-5.19 6.22-1.012 0-1.965-.526-2.291-1.148 0 0-.502 1.91-.623 2.377-.226.869-.835 1.958-1.243 2.622.936.29 1.93.446 2.96.446 5.524 0 10-4.477 10-10S15.524 0 10 0Z"
												fill="#fff" /></svg>
									</a>
									<a class="flex items-center justify-center" href="https://www.linkedin.com/company/smore/" rel="noopener" target="_blank">
										<svg width="22" height="20" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M9.1001 10.7C9.1001 10.7 9.1001 8 9.1001 7C9.1001 6 8.7001 5.4 7.9001 5.4C7.0001 5.4 6.6001 6 6.6001 7C6.6001 8.1
                          6.6001 10.7 6.6001 10.7H4.4001V3.6H6.5001V4.6C6.5001 4.6 7.1001 3.4 8.6001 3.4C10.1001 3.4 11.2001 4.3 11.2001 6.2C11.2001
                          8.1 11.2001 10.7 11.2001 10.7H9.1001ZM1.9001 2.6C1.2001 2.6 0.600098 2 0.600098 1.3C0.600098 0.6 1.2001 0 1.9001 0C2.6001
                          0 3.2001 0.6 3.2001 1.3C3.2001 2 2.6001 2.6 1.9001 2.6ZM3.0001 10.7H0.800098V3.6H3.0001V10.7Z"
												fill="white" />
										</svg>
									</a>
									<a
										class="flex items-center justify-center text-white"
										href="https://x.com/SmoreNewsletter"
										rel="noopener"
										target="_blank">
										<svg viewBox="0 0 24 24" aria-hidden="true" class="w-5 fill-current"
											><g
												><path
													d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
												></path
												></g
											></svg>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
